import { render, staticRenderFns } from "./factory.vue?vue&type=template&id=b010183a&scoped=true"
import script from "./factory.vue?vue&type=script&lang=js"
export * from "./factory.vue?vue&type=script&lang=js"
import style0 from "./factory.vue?vue&type=style&index=0&id=b010183a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b010183a",
  null
  
)

export default component.exports